import { render, staticRenderFns } from "./DataTableOrdering.vue?vue&type=template&id=05d20b17&scoped=true&"
import script from "./DataTableOrdering.vue?vue&type=script&lang=js&"
export * from "./DataTableOrdering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d20b17",
  null
  
)

export default component.exports